import { FC, useMemo } from 'react';
import i18next from 'i18next';

import { Segment, SegmentType } from '~src/interfaces/segment.interface';
import Dialog from '~src/shared/dialogs/dialog/Dialog';
import CustomChip from '~src/modules/surveys/components/schedules/scheduleItem/templates/sections/customInputs/CustomChip';
import { getUserFullName, User } from '~src/interfaces/user.interface';
import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';
import SvgIcon from '~src/shared/SvgIcon';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';

import {
  CtaText,
  ModalChipsWrapper,
  ModalWrapper,
  ButtonWrapper,
  ButtonMargin,
  ModalTitle,
  ModalSubTitle,
} from './overrideConfirmationDialog.sc';

interface Props {
  people: User[];
  show: boolean;
  onHide: () => void;
  onSubmit: () => void;
  loading: boolean;
  headerTextKey: string;
  titleKey: string;
  subTitleKey: string;
  ctaTextKey: string;
  submitTextKey: string;
  cancelTextKey: string;
  t: i18next.TFunction;
}

const OverrideConfirmationDialog: FC<Props> = props => {
  const chipsValues = useMemo((): Segment[] => {
    return props.people.reduce((acc: Segment[], val) => {
      acc.push({
        id: val.uuid,
        image_url: val.imageUrl || '',
        type: SegmentType.User,
        meta: {
          name: getUserFullName(val),
          firstname: val.firstname,
          lastname: val.lastname,
          email: val.email,
          manager_uuid: null, //TODO this whole business is rather … unclean
        }
      });
      return acc;
    }, []);
  }, [props.people]);

  return (
    <Dialog
      titleKey={props.headerTextKey}
      title={props.t(props.headerTextKey)}
      show={props.show}
      onHide={props.onHide}
    >
      <ModalWrapper>
        <SvgIcon width={60} name="iconDanger" />
        <ModalTitle data-translation={props.titleKey}>{props.t(props.titleKey)}</ModalTitle>
        <ModalSubTitle data-translation={props.subTitleKey}>{props.t(props.subTitleKey)}</ModalSubTitle>
        <ModalChipsWrapper>
          {chipsValues.map(segment => (
            <CustomChip key={segment.id} locked value={segment} />
          ))}
        </ModalChipsWrapper>
        <CtaText data-translation={props.ctaTextKey}>{props.t(props.ctaTextKey)}</CtaText>
        <ButtonWrapper>
          <ButtonMargin>
            <SecondaryButton onClick={props.onHide} data-translation={props.cancelTextKey}>
              {props.t(props.cancelTextKey)}
            </SecondaryButton>
          </ButtonMargin>
          <PrimaryButtonLoading
            isLoading={props.loading}
            $buttonColor="reddish"
            onClick={props.onSubmit}
            data-translation={props.submitTextKey}
          >
            {props.t(props.submitTextKey)}
          </PrimaryButtonLoading>
        </ButtonWrapper>
      </ModalWrapper>
    </Dialog>
  );
};

export default OverrideConfirmationDialog;
